// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyDetailsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyDetailsWebApiHandler_details,
  RentalManagerUserPropertyDetailsWebApiHandler_details_Path,
  RentalManagerUserPropertyDetailsWebApiHandler_overview,
  RentalManagerUserPropertyDetailsWebApiHandler_overview_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GetUserPropertyDetailsResponseWebDto,
  GetUserPropertyOverviewResponseWebDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface DetailsParams {
  includeAverageDescriptionLength?: boolean;
  includeDeliveryMethod?: boolean;
  includeHasVrModels?: boolean;
  includeTopDupesDetails?: boolean;
  includeVrModels?: boolean;
  includeWebAnalytics?: boolean;
  listingAlias: ListingAlias;
}
interface OverviewParams {
  includeRestrictions?: boolean;
  listingAlias: ListingAlias;
  useUpliftBrainTestData?: boolean;
}

export type RentalManagerUserPropertyDetailsWebApiHandler_details_Options = UseQueryOptions<
  GetUserPropertyDetailsResponseWebDto,
  unknown,
  GetUserPropertyDetailsResponseWebDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserPropertyDetailsWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserPropertyDetailsWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserPropertyDetailsWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDetailsWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyDetailsWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get property details
 */
export const useRentalManagerUserPropertyDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyDetailsWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDetailsWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyDetailsWebApiHandler_details.getKey =
  RentalManagerUserPropertyDetailsWebApiHandler_details_GetKey;

export type RentalManagerUserPropertyDetailsWebApiHandler_overview_Options = UseQueryOptions<
  GetUserPropertyOverviewResponseWebDto,
  unknown,
  GetUserPropertyOverviewResponseWebDto,
  readonly [string, OverviewParams]
>;

const RentalManagerUserPropertyDetailsWebApiHandler_overview_GetKey = (getParams: OverviewParams) =>
  [RentalManagerUserPropertyDetailsWebApiHandler_overview_Path, getParams] as const;

export const RentalManagerUserPropertyDetailsWebApiHandler_overview_queryOptions = (
  getParams: OverviewParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDetailsWebApiHandler_overview_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyDetailsWebApiHandler_overview(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get property details overview
 */
export const useRentalManagerUserPropertyDetailsWebApiHandler_overview = (
  getParams: OverviewParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyDetailsWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDetailsWebApiHandler_overview_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyDetailsWebApiHandler_overview.getKey =
  RentalManagerUserPropertyDetailsWebApiHandler_overview_GetKey;
